var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeadsetIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.375 29.119v-4.5c-6.262-.325-11.25-5.525-11.25-11.863C3.125 6.206 8.45.881 15 .881s11.875 5.325 11.875 11.875c0 6.188-4.3 12.413-10.712 15.5l-1.788.863ZM15 3.38c-5.175 0-9.375 4.2-9.375 9.375S9.825 22.13 15 22.13h1.875v2.875c4.55-2.875 7.5-7.6 7.5-12.25 0-5.175-4.2-9.375-9.375-9.375Zm-1.25 14.375h2.5v2.5h-2.5v-2.5Zm2.5-1.875h-2.5c0-4.062 3.75-3.75 3.75-6.25 0-1.375-1.125-2.5-2.5-2.5a2.507 2.507 0 0 0-2.5 2.5H10c0-2.762 2.238-5 5-5s5 2.238 5 5c0 3.125-3.75 3.438-3.75 6.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadsetIcon);
export default __webpack_public_path__ + "static/media/headsetIcon.0209ce60da5848c5b2c25eb5b70c9064.svg";
export { ForwardRef as ReactComponent };